import { DatiGeneraliDTO } from "./swagger-accident.types";
import { VeicoloDTO } from "./swagger-vehicle.types";

export type BozzaDTO = {
  datiGenerali: DatiGeneraliDTO;
  veicoloA: VeicoloDTO;
  veicoloB: VeicoloDTO;
};

export type InfoRequestDTO = {
  targa?: string;
  dataNascita?: string;
  proclie?: string;
};

export type InfoResponseDTO = {
  idBozza: string;
  nuovaDenuncia: boolean;
  step: BozzaStepDTO;
};

export enum BozzaStepDTO {
  APERTA = "APERTA",
  VEICOLO_A = "VEICOLO_A",
  VEICOLO_B = "VEICOLO_B",
  DATI_GENERALI = "DATI_GENERALI",
  DA_FIRMARE = "DA_FIRMARE",
  ATTESA_CONDUCENTE_A = "ATTESA_CONDUCENTE_A",
}
